export const IconUserProfileContact: {
  name: 'icon_user_profile_contact-8fec5aca5403'
} = {
  name: 'icon_user_profile_contact-8fec5aca5403'
}
